import React, { useEffect, useState } from 'react';
import { Image } from 'primereact/image';
//import { useHistory } from 'react-router-dom';


function Footer() {
     

    return (
        <div className="">
                       
           
            
            </div>
        );
    
}
export default Footer;